export class SaveCompletionRegisterViewModel {
    completionDate: string | null = null;
    personInChargeUserId: string | null = null;

    constructor(data?: Partial<SaveCompletionRegisterViewModel>) {
        Object.assign(this, data);
    }
}
